import { ReservationState } from "../../util/useReservationState";
import { FormWrapper } from "../FormWrapper";
import { Stack, Typography } from "@mui/material";
import Space from "../Space";
import { ColorHexCodes } from "../../util/Color";
import CancellableReservationSummary from "../CancellableReservationSummary";
import lineLogin from "../../img/line_login.png";
import { useGTMWithEvent } from "../GTM/useGTMwithEvent";
import { useEffect } from "react";

export default function Done({ state }: { state: ReservationState }) {
  useGTMWithEvent(state.data.store?.google_tag_manager_id ?? "", "CompleteRegistration");
  useEffect(() => window.scrollTo(0, 0), []);

  if (!state.data.rid || !state.data.store || !state.data.course || !state.data.date) {
    state.setValue("error", true);
    return <></>;
  }

  return (
    <FormWrapper currentIndex={4} skipConfirm={state.data.store?.skip_confirm}>
      {state.data.lineLoginUrl && (
        <div>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography>LINEログインして予約通知を受け取る</Typography>
            <a href={state.data.lineLoginUrl} target="_blank" rel="noopener noreferrer">
              <img src={lineLogin} width="110" height="32" alt="Line login" />
            </a>
          </Stack>

          <Space h={15} />
          <div style={{ height: 1, background: `#${ColorHexCodes.MainColorGreen}` }} />
          <Space h={15} />
        </div>
      )}

      <CancellableReservationSummary data={{ ...state.data, rid: state.data.rid, store: state.data.store, nominated_staff_name: state.data.staff?.nominee_name, course: state.data.course, date: state.data.date }} />
      <Space h={40} />
    </FormWrapper>
  );
}
